import { useState } from "react";
import { Camera, Search, ChevronLeft } from "lucide-react";
import type { CameraCatalog, CameraSite } from "./lib/types";
import { cameraLabel } from "./lib/cameraAlerts";

export default function CameraCatalogPanel({
  catalog,
  error,
  onSelect,
  onRetry,
}: {
  catalog: CameraCatalog | null;
  error: string;
  onSelect: (camera: CameraSite) => void;
  onRetry: () => void;
}) {
  const [query, setQuery] = useState("");
  const cameras = (catalog?.cameras || []).filter((camera) =>
    `${camera.description} ${camera.sourceType} ${camera.sourceStatus} ${camera.sourceRecordId}`.includes(
      query.trim(),
    ),
  );
  return (
    <div className="camera-browser">
      {error ? (
        <div className="camera-catalog-error" role="status">
          {error}
          <button className="text-btn" onClick={onRetry}>
            ניסיון נוסף
          </button>
        </div>
      ) : !catalog ? (
        <p role="status">טוענים את מאגר המצלמות…</p>
      ) : !catalog.available ? (
        <p role="status">מאגר המצלמות אינו זמין כרגע.</p>
      ) : (
        <>
          <p className="catalog-intro">
            <strong>{catalog.cameras.length} נקודות</strong> במאגר המצלמות ·
            כולל עמדות לא פעילות. הפעילות בפועל אינה נבדקת בזמן אמת.
          </p>
          <label className="catalog-search">
            <Search size={18} />
            <input
              aria-label="חיפוש במאגר המצלמות"
              placeholder="כביש, צומת או סוג מצלמה"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </label>
          <div className="catalog-results" aria-label="מצלמות מהמאגר">
            {cameras.length === 0 && <p>לא נמצאו נקודות מתאימות.</p>}
            {cameras.map((camera) => (
              <button
                key={camera.id}
                className="catalog-result"
                onClick={() => onSelect(camera)}
              >
                <span
                  className={`catalog-result-icon ${camera.status.toLowerCase()}`}
                >
                  <Camera size={20} />
                </span>
                <span>
                  <strong>{camera.description || camera.name}</strong>
                  <small>
                    {cameraLabel(camera)} · {camera.sourceStatus}
                  </small>
                </span>
                <ChevronLeft size={17} />
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
